function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.7135 19.0718C19.0034 19.0718 18.4277 18.4961 18.4277 17.786V6.21372C18.4277 5.50359 19.0034 4.92792 19.7135 4.92792V4.92792C20.4237 4.92792 20.9993 5.50359 20.9993 6.21372V17.786C20.9993 18.4961 20.4237 19.0718 19.7135 19.0718V19.0718Z",
  stroke: "#627D98",
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.569 19.0718C13.8589 19.0718 13.2832 18.4962 13.2832 17.786V8.78538C13.2832 8.07525 13.8589 7.49957 14.569 7.49957V7.49957C15.2791 7.49957 15.8548 8.07525 15.8548 8.78538V17.786C15.8548 18.4962 15.2791 19.0718 14.569 19.0718V19.0718Z",
  stroke: "#627D98",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.42839 19.0719C8.71825 19.0719 8.14258 18.4963 8.14258 17.7861V11.3571C8.14258 10.647 8.71825 10.0713 9.42839 10.0713V10.0713C10.1385 10.0713 10.7142 10.647 10.7142 11.3571V17.7861C10.7142 18.4963 10.1385 19.0719 9.42839 19.0719V19.0719Z",
  stroke: "#627D98",
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.28385 19.0718C3.57372 19.0718 2.99805 18.4961 2.99805 17.786V13.9286C2.99805 13.2184 3.57372 12.6428 4.28385 12.6428V12.6428C4.99399 12.6428 5.56966 13.2184 5.56966 13.9286V17.786C5.56966 18.4961 4.99399 19.0718 4.28385 19.0718V19.0718Z",
  stroke: "#627D98",
  strokeLinecap: "round"
});

function SvgIcoWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWifi);
export default __webpack_public_path__ + "static/media/ico-wifi.7b7bf346.svg";
export { ForwardRef as ReactComponent };